import "./style.css";
import layout from "./layout.html";

export default class StoryImages {
  static selector = ".story__images";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }

  onReady = () => {};

  onComplete = () => {};

  onResize = () => {};
}
